import React, { Component } from "react";
import PropTypes from "prop-types";
import $ from "jquery";
import { jarallax } from "jarallax";

import { Textfit } from "react-textfit";

import "../styles/components/HeroBanner.css";

export default class HeroBannerSmall extends Component {
  componentDidMount() {
    $(document).ready(() => {
      if (window && window.outerWidth > 992) {
        jarallax($(".jarallax"), {
          speed: 0.5,
          type: this.props.changeOpacity ? "scroll-opacity" : "scroll",
          imgPosition: this.props.fromTop ? `center bottom` : `center 50px`
        });
      }
    });
  }

  render() {
    const {
      backgroundImage,
      headerText,
      smallContainer,
      fulljustify
    } = this.props;

    return (
      <div
        className={`hero hero--small  ${
          this.props.backgroundImage.includes("svg")
            ? "jarallax-svg"
            : "jarallax"
        }`}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundColor: "rgb(230,230,230)"
        }}
      >
        <div
          className={`hero-header container ${
            smallContainer ? "container-small" : ""
          }`}
        >
          <div className="row">
            <div className="col-12">
              <Textfit
                className={`text-fit ${fulljustify ? "fulljustify" : ""}`}
                mode="single"
                max={200}
                throttle={200}
              >
                {headerText}
              </Textfit>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HeroBannerSmall.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  centerForce: PropTypes.bool,
  fontSize: PropTypes.number,
  headerText: PropTypes.string,
  smallContainer: PropTypes.bool,
  fulljustify: PropTypes.bool,
  changeOpacity: PropTypes.bool,
  fromTop: PropTypes.bool,
  paddingTop: PropTypes.string
};

HeroBannerSmall.defaultTypes = {
  centerForce: false,
  fontSize: 200,
  smallContainer: false,
  fulljustify: false,
  changeOpacity: false,
  paddingTop: 0,
  fromTop: false
};
